// extracted by mini-css-extract-plugin
export default {"title":"ActivityLogViewCard_title__KK4G1","label":"ActivityLogViewCard_label__RCDh0","section":"ActivityLogViewCard_section__YgTnZ"};